export enum TypePdf {
  FACTURE_EXPEDITION = "FACTURE_EXPEDITION",
  AVOIR_CLIENT = "AVOIR_CLIENT",
  COMMANDE_FOURNISSEUR = "COMMANDE_FOURNISSEUR",
  SPECIFICATION = "SPECIFICATION",
  DOSSIER_PRODUCTION = "DOSSIER_PRODUCTION",
  FICHE_PALETTE = "FICHE_PALETTE",
  ETIQ_CARTON = "ETIQ_CARTON",
  ETIQ_CARTON_EAN13 = "ETIQ_CARTON_EAN13",
  ETIQ_BARQUETTE = "ETIQ_BARQUETTE",
  BL_CLIENT = "BL_CLIENT",
  FICHE_PALETTE_EXPEDITION = "FICHE_PALETTE_EXPEDITION",
  CONFIRMATION_COMMANDE_CLIENT = "CONFIRMATION_COMMANDE_CLIENT",
  SUIVI_PRODUCTION = "SUIVI_PRODUCTION",
  BON_TRANSFERT = "BON_TRANSFERT",
  DOSSIER_PRODUCTION_V2 = "DOSSIER_PRODUCTION_V2",
  FICHE_NC = "FICHE_NC",
}
